import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const ctaBackground = svgToTinyDataUri(
  `<svg width="695" height="520" viewBox="0 0 695 520" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.05">
<path d="M0 444.68L147.473 40.5148C147.473 40.5148 220.046 20.345 296.776 8.45117C221.23 174.038 175.64 327.776 175.64 351.496C175.64 375.216 182.144 418.925 279.397 418.925C394.825 418.925 541.285 344.667 541.285 231.223C541.285 382.836 387.051 478.756 217.139 478.756C90.4475 478.733 0 444.68 0 444.68Z" fill="#501283"/>
<path d="M541.285 231.201C541.285 382.814 387.05 478.733 217.138 478.733C90.4466 478.733 1.42041 444.68 1.42041 444.68C1.42041 444.68 77.6763 520 272.182 520C466.644 520 694.507 393.125 694.507 209.539C694.507 -43.2395 348.114 3.38618 348.114 3.38618L295.116 120.651C295.116 120.651 344.863 114.659 386.102 114.659C444.032 114.659 541.285 141.5 541.285 231.201Z" fill="#501283"/>
</g>
</svg>`
);
